<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">Questions Administration</b-navbar-brand>
			<b-collapse id="nav-collapse-sub" is-nav>
				<b-navbar-nav>
				<a href="#" @click="loadQuestionnaireTab()">Questionnaires</a>
				<a href="#" @click="loadQuestionTab()">Questions</a>
				<a href="#" @click="onLoad()" v-if="questionnaire">Reload</a>
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
	<div id="content">
		<b-modal id="modMessage" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="CMS Admin">
			<p class="my-4">{{message}}</p>
		</b-modal>
		<b-modal id="modSure" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="Really?">
			<p class="my-4">Are you sure?</p>
			<p class="my-4">{{deleteWarningMessage}}</p>
			<template #modal-footer="{ ok, cancel }">
				<b-button variant="success" @click="delMethod()">Yes</b-button>
				<b-button variant="danger" @click="cancel()">No</b-button>
			</template>
		</b-modal> 
		<div class="row" v-if="tabIndex === 0">
			<div class="col-md-3 mb-4">
				<h2>Questionnaires</h2>
				<div class="row mb-1" v-for="q in questionnaires" :key="q.id">
					<b-button @click="selectQuestionnaire(q)">{{q.title}}</b-button>
				</div>
				<div class="row mt-2 mb-1">
					<b-button @click="newQuestionnaire()" variant="success"><b-icon-plus font-scale="1.5"/> New Questionnaire</b-button>
				</div>
				<div class="row mb-1" v-if="questionnaire">
					<b-button @click="saveQuestionnaire()" variant="primary"><b-icon icon="check-circle-fill" font-scale="1.5"/> Save Current Questionnaire</b-button>
				</div>
				<div class="row mb-1" v-if="questionnaire">
					<b-button @click="deleteQuestionnairePressed()" variant="danger"><b-icon-trash font-scale="1.5"/> Delete Current Questionnaire</b-button>
				</div> 
			</div>
			<div class="col-md-9" v-if="questionnaire">
				<div class="m-5 mt-0">
					<h2>{{questionnaire.title}}</h2>
					<div class="mb-2"><small>ID: {{questionnaire.id}}</small></div>
					Title: <b-form-input class="mb-2" v-model="questionnaire.title"></b-form-input> 
					Key (use title no spaces): <b-form-input class="mb-2" v-model="questionnaire.key"></b-form-input>
					Tags: <b-form-input class="mb-2" v-model="questionnaire.tags"></b-form-input>
					<div class="col" v-if="question && (!createNewQuestion && !editQuestion)">
						<div class="new-question-card m-5 mt-0">
							<h3>Add a question:</h3>
							<b-row>
								<div class="col-5 text-center">
									<b-row><p>Choose from library:</p></b-row>
									<b-row><b-form-select  v-model="question" :options="questions" > </b-form-select></b-row>
								</div>
								<div class="col-2  text-center">
									<p>Or</p>
								</div>
								<div class="col-5  text-center">
									<b-button @click="createQuestionPressed">Create a new question</b-button> 
								</div>
							</b-row>
							<!--  End of new question. Add it to Questionnaire -->
							<div class="card2 col">
								<b-row>
									<b-col cols="8"><p>Add this question to {{this.questionnaire.title}}?</p></b-col>
									<b-col><b-button @click="addQuestionToQuestionnaire()">Save</b-button> </b-col>
									<b-col><b-button @click="cancelAddQuestionToQuestionnaire()">Cancel</b-button> </b-col>
								</b-row>
							</div>
						</div>
					</div>
					<div class="col" v-if="question && (createNewQuestion || editQuestion)">
						<div class="new-question-card m-5 mt-0">
							<h3 v-if="createNewQuestion">New question:</h3>
							<div v-if="editQuestion"><h3>Edit question:</h3><p>{{question.id}}</p></div>
							<b-row>
								Text: <b-form-input class="mb-2" v-model="question.text"></b-form-input>
								<b-form-group label="Answer type" v-slot="{ ariaDescribedby }">
									<b-form-checkbox-group
									v-model.number="question.questionType"
									:options="[0,1,2,3,4,5].map((e) => { return {text: switchAnswerType(e), value: e}; })"
									:aria-describedby="ariaDescribedby"
									button-variant="primary"
									size="lg"
									name="buttons-2"
									></b-form-checkbox-group>
								</b-form-group>
							</b-row>
							<div class="col" v-if="question.questionType == 4 || question.questionType == 5">
								<p>Possible answers:</p>
								<b-button class="answerButton" v-for="e in this.question.possibleAnswers" :key="e.id" @click="removeAnswerFromQuestion(question, e)">
									<p>{{e.answer.text}}</p><p>(val: {{e.answer.value}})</p><b-icon icon="x-circle" font-scale="1.5"/>
								</b-button>
								<b-col>
									Text: <b-form-input class="mb-2" v-model="answerText"></b-form-input>Value:<b-form-input class="mb-2" v-model="answerValue"></b-form-input>
								</b-col>
								<b-col>
									<b-button @click="addAnswerToQuestion()"  variant="success">Add Answer</b-button>
								</b-col>
							</div>
							<div class="card2 col">
								<b-row>
									<b-col v-if="createNewQuestion"><b-button @click="saveQuestion(true)">Save and add to questionnaire</b-button> </b-col>
									<b-col v-if="editQuestion"><b-button @click="saveQuestion(false)">Save</b-button> </b-col>
									<b-col><b-button @click="cancelCreateQuestion()">Cancel</b-button> </b-col>
								</b-row>
							</div>
						</div>
					</div>
					<b-container class="bv-example-row">
						<b-row>
							<b-col>Questions ({{questionnaire.questionnaireQuestions.length}}): </b-col>
							<b-col><b-button @click="newQuestion()"  variant="success">Add Question</b-button></b-col>
						</b-row>
					</b-container>
					<div v-for="qq in questionnaire.questionnaireQuestions" :key="qq.questionId">
						<div class="question-card">
							<b-container class="bv-example-row">
								<b-row>
									<b-col cols="8"><h5>{{qq.question.text}}</h5> </b-col>
									<b-col><b-button @click="question = qq.question; editQuestion = true">Edit</b-button> </b-col>
									<b-col><b-button @click="removeQuestionFromQuestionnaire(qq.question)" variant="danger">Remove</b-button> </b-col>
								</b-row>
							<p>Answer type: {{switchAnswerType(qq.question.questionType)}}</p>
							</b-container>
							<div class="row-md-2" >
								<div v-for="a in qq.question.possibleAnswers" :key="a.answerId"> 
									<p>{{a.answer.text}}</p>
								</div>
							</div> 
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row" v-if="tabIndex === 1">
			<b-row class="m-3">
				<b-col><h2>Question Library</h2></b-col>
				<b-col class="text-center"><b-button variant="success" @click="createQuestionPressed">Create a new question<b-icon-plus font-scale="1.5"/></b-button></b-col>
			</b-row>
			<div v-if="question && (createNewQuestion || editQuestion)" class="new-question-card m-5 mt-0">
				<h3 v-if="createNewQuestion">New question:</h3>
				<div v-if="editQuestion"><h3>Edit question:</h3><p>{{question.id}}</p></div>
				<b-row>
					Text: <b-form-input class="mb-2" v-model="question.text"></b-form-input>
					<b-form-group label="Answer type" v-slot="{ ariaDescribedby }">
						<b-form-checkbox-group
						v-model="question.questionType"
						:options="[0,1,2,3,4,5].map((e) => { return {text: switchAnswerType(e), value: e}; })"
						:aria-describedby="ariaDescribedby"
						button-variant="primary"
						size="lg"
						name="buttons-2"
						></b-form-checkbox-group>
					</b-form-group>
				</b-row>
				<div class="col" v-if="question.questionType == 4 || question.questionType == 5">
					<p>Possible answers:</p>
					<b-button class="answerButton" v-for="e in this.question.possibleAnswers" :key="e.id" @click="removeAnswerFromQuestion(question, e)">
						<p>{{e.answer.text}}</p><p>(val: {{e.answer.value}})</p><b-icon icon="x-circle" font-scale="1.5"/>
					</b-button>
					<b-col>
						Text: <b-form-input class="mb-2" v-model="answerText"></b-form-input>Value:<b-form-input class="mb-2" v-model="answerValue"></b-form-input>
					</b-col>
					<b-col>
						<b-button @click="addAnswerToQuestion()"  variant="success">Add Answer</b-button>
					</b-col>
				</div>
				<div class="card2 col">
					<b-row>
						<b-col><b-button @click="saveQuestion(false)">Save</b-button> </b-col>
						<b-col><b-button @click="cancelCreateQuestion()">Cancel</b-button> </b-col>
					</b-row>
				</div>
			</div>
			<div v-for="q in questions" :key="q.questionId">
				<div class="question-card">
					<b-container class="bv-example-row">
						<b-row>
							<b-col cols="8"><h5>{{q.text}}</h5><p style="font-size:10px">{{q.value.id}}</p></b-col>
							<b-col><b-button @click="question = q.value; editQuestion = true;">Edit</b-button> </b-col>
							<b-col><b-button @click="deleteQuestionPressed(q.value)" variant="danger">Delete</b-button> </b-col>
						</b-row>
					</b-container>
					<p>Answer type: {{switchAnswerType(q.value.questionType)}}</p>
					<div class="row-md-2" >
						<div v-for="a in q.value.possibleAnswers" :key="a.answerId"> 
							<p>{{a.answer.text}}</p>
						</div>
					</div> 
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script>
export default {
  name: 'Questions',
  data() {
	return{
		tabIndex: 0,
		questionnaires: null,
		questionnaire: null,
		questions: null,
		question: null,
		createNewQuestion: false,
		editQuestion: false,
		answerText: null,
		answerValue: null,
		delMethod: null,
		message: null,
		deleteWarningMessage: null,
		error: null, 
	}
  },
  methods: {
	getQuestionnaires: function(autoSelect){
		this.$http.get(this.$config.ApiUri + "/Questionnaires")
			.then((result) => {
				this.questionnaires = result.data;
				if (autoSelect) {
					if (this.questionnaires.length > 0) {
						this.questionnaire = this.questionnaires[0];
					}
				}
			}
		)
	},
	selectQuestionnaire: function(p) {
		this.questionnaire = p;
	},
	selectQuestion: function(qu) {
		this.question = qu;
		console.log(qu);
	},
	newQuestionnaire() {
		this.questionnaire = { 
			"id": "",
			"key": "",
			"title": "",
			"questionnaireQuestions": []
		};
	},
	newQuestion: function() {
		this.editQuestion = false;
		this.question = {
			id: "",
			text: "",
			questionType: 0,
			possibleAnswers: []
		}
	},
	addQuestionToQuestionnaire: function() {
		if (this.questionnaire.id != null && this.questionnaire.id != "" && this.question.id != null && this.question.id != "") {
			this.$http.post(this.$config.ApiUri + "/Questionnaires/" + this.questionnaire.id + "/QuestionnaireQuestions/" + this.question.id)
				.then((result) => {
					this.questionnaire = result.data;
					this.getQuestionnaires(false);
					this.showMessage("Question added to questionnaire!");
				}
			).catch(() => { this.showError(); });
		}
		this.question = null;
	},
	removeQuestionFromQuestionnaire: function(q) {
		if (this.questionnaire.id != null && this.questionnaire.id != "") {
			this.$http.delete(this.$config.ApiUri + "/Questionnaires/" + this.questionnaire.id + "/QuestionnaireQuestions/" + q.id)
				.then((result) => {
					this.questionnaire = result.data;
					this.getQuestionnaires(false);
					this.showMessage("Question removed from questionnaire!");
				}
			).catch(() => { this.showError(); });
		}
	},
	cancelAddQuestionToQuestionnaire: function() {
		this.createNewQuestion = false;
		this.question = null;
	},
	saveQuestionnaire: function(){
		if (this.questionnaire.id == null || this.questionnaire.id == "") {
			this.$http.post(this.$config.ApiUri + "/Questionnaires", this.questionnaire)
				.then((result) => {
					this.questionnaire = result.data;
					this.getQuestionnaires(false);
					this.showMessage("Questionnaire created OK!");
				}
			).catch(() => { this.showError(); });
		}
		else {
			this.$http.put(this.$config.ApiUri + "/Questionnaires/" + this.questionnaire.id, this.questionnaire)
				.then((result) => {
					this.questionnaire = result.data;
					this.getQuestionnaires(false);
					this.showMessage("Questionnaire saved OK!");
				}
			).catch(() => { this.showError(); });
		} 
		this.createNewQuestion = false;
		this.question = null;
	},
	deleteQuestionnairePressed() {
		this.deleteWarningMessage = "Deleting a questionnaire";
		this.delMethod = this.deleteQuestionnaire;
		this.$bvModal.show('modSure');
	},
	deleteQuestionPressed(q) {
		this.deleteWarningMessage = "Deleting a question WILL REMOVE IT from any questionnaires it is on. AND PERMANENTLY DELETE customers answers to those questions. If you are unsure, remove it from any questionnaires instead so it is not visible on the app.";
		this.question = q;
		this.delMethod = this.deleteQuestion;
		this.$bvModal.show('modSure');
	},
	deleteQuestionnaire() {
		this.$bvModal.hide('modSure');
		this.$http.delete(this.$config.ApiUri + "/Questionnaires/" + this.questionnaire.id)
			.then(() => {
				this.questionnaire = null;
				this.getQuestionnaires(true);
				this.showMessage("Questionnaire deleted OK!");
			}
		).catch((error) => { this.showError("Sorry, that Questionnaire cannot be deleted. (" + error + ")"); });
	},
	deleteQuestion() {
		this.$bvModal.hide('modSure');
		this.$http.delete(this.$config.ApiUri + "/Questions/" + this.question.id)
			.then(() => {
				this.question = null;
				this.getQuestions(true);
				this.showMessage("Question deleted OK!");
			}
		).catch((error) => { this.showError("Sorry, that question cannot be deleted. (" + error + ")"); });
	},
	getQuestions: function(){
		this.$http.get(this.$config.ApiUri + "/Questions")
			.then((result) => {
				this.questions = [];
				result.data.forEach((item) => {
					this.questions.push({
						value : item,
						text: item.text
					});
				});
			}
		)
	},
	createQuestionPressed: function() {
		this.newQuestion();
		this.createNewQuestion = true;
	},
	cancelCreateQuestion: function() {
		this.createNewQuestion = false;
		this.editQuestion = false;
	},
	addAnswerToQuestion: function() {
		this.question.possibleAnswers.push({ "answer": { "text": this.answerText, "value": this.answerValue}});
		this.answerText = null;
		this.answerValue = null;
	},
	removeAnswerFromQuestion: function(qu, a) {
		var i = qu.possibleAnswers.indexOf(a);
		qu.possibleAnswers.splice(i, 1);
	},
	saveQuestion: function(addToQuestionnaire){
		if (this.question.id == null || this.question.id == "") {
			this.$http.post(this.$config.ApiUri + "/Questions", this.question)
				.then((result) => {
					this.question = result.data;
					this.createNewQuestion = false;
					this.getQuestions(false);
					this.showMessage("Question created OK!");
					if (addToQuestionnaire) {
						this.addQuestionToQuestionnaire();
					}
				}
			).catch(() => { this.showError(); });
		} else {
			this.$http.put(this.$config.ApiUri + "/Questions/" + this.question.id, this.question)
				.then((result) => {
					this.question = result.data;
					this.editQuestion = false;
					this.getQuestions(false);
					this.showMessage("Question saved OK!");
				}
			).catch(() => { this.showError(); });
		}
	},
	loadQuestionnaireTab() {
		this.tabIndex = 0;
		this.editQuestion = false;
		this.createNewQuestion = false;
		this.question = null;
		this.getQuestionnaires(true);
	},
	loadQuestionTab() {
		this.tabIndex = 1;
		this.editQuestion = false;
		this.createNewQuestion = false;
		this.question = null;
		this.getQuestions(true);
	},
	switchAnswerType(type) {
		switch(type) {
			case 0: return "Free text";
			case 1: return "Free text (number)";
			case 2: return "Free text (currency)";
			case 3: return "Free text (%)";
			case 4: return "Multiple choice";
			case 5: return "Dropdown";
			default: return "Unknown"
		}
	},
	showMessage(message) {
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	showError(message) {
		if (!message) { message = "Sorry, that didn't work, please contact Tech"; }
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	onLoad() {
		this.getQuestionnaires(true);
	}
  },
  mounted: function() { this.onLoad(); }
}
</script>

<style>
.modal-header .close {
  display:none;
}
#criteria .btn-sm {
	margin:3px;
	font-size:10px;
}
.question-card {
	padding: 20px;
	margin-bottom: 20px;
	background-color:aliceblue;
}
.new-question-card {
	padding: 20px;
	margin-bottom: 20px;
	background-color:aliceblue;
}
.card2 {
	padding: 20px;
	margin: 20px;
	background-color:white;
}
.activeBtn {
  background: rgb(243, 16, 0) !important;
}
.answerButton {
	background: grey;
	font-size: 4px;
	margin: 2px;
}
</style>